import { TableContainer, Table, Thead, Tbody, Tr, Th, Td, Flex, Input, Button } from '@chakra-ui/react'
import Header from '../../../components/Header'
import { HeadingPages } from '../../../components/HeadingPages'
import { Layout } from '../../../components/Layout'
import { useMutation, QueryErrorResetBoundary } from 'react-query'
import { ErrorBoundary } from 'react-error-boundary'
import { formatPrice } from '../../../utils/formatPrice'
import { useEffect, useState } from 'react'
import { api } from '../../../services/api'
import { format } from 'date-fns'
import Axios from 'axios'
import { ImFileExcel } from 'react-icons/im'
import { Loader } from '../../../components/ComponentLoader/Loader'
import { useForm } from 'react-hook-form'

const columns = ['Data do pedido', 'N. Pedido', 'Nota Fiscal', 'Cód. Kangu', 'Valor Frete', 'Valor real + 30%']

export function ControleKangu() {
  const { handleSubmit, register, setValue } = useForm()

  const {
    data: listKangu,
    isLoading,
    mutateAsync,
  } = useMutation({
    async mutationFn(values) {
      const { data } = await api.get('/site/v2/crm-controle/listar-controle-kangu', {
        params: {
          ...values,
        },
      })

      return data.map((item, index) => {
        return {
          id: index,
          date: item.data_fechamento ? format(new Date(item.data_fechamento), 'dd/MM/yyyy HH:mm') : 'Não informado',
          number: item.numero_pedido,
          code: item.codigo_kangu,
          unique: item.numero_nota,
          freight: formatPrice(item.valor_fechamento),
          real: formatPrice(item.valor_simulado),
        }
      })
    },
  })

  async function handleSearch(data) {
    try {
      await mutateAsync(data)
    } catch (error) {
      console.log(error)
    }
  }

  const [loading, setLoading] = useState(false)

  async function generateExcel() {
    if (!listKangu) return
    if (listKangu.length === 0) return

    setLoading(true)

    const header = ['Data do pedido', 'N. Pedido', 'Nota Fiscal', 'Cód. Kangu', 'Valor Frete', 'Valor real + 30%']

    const dataItems = listKangu?.map((item) => {
      return {
        'Data do pedido': item.date,
        'N. Pedido': item.number,
        'N. único': item.unique,
        'Cód. Kangu': item.code,
        'Valor Frete': item.freight,
        'Valor real + 30%': item.real,
      }
    })

    try {
      const response = await Axios.post(
        'https://apihomolog.innovationbrindes.com.br/node/transform-to-excel',
        {
          header: header,
          data: dataItems,
        },
        { responseType: 'arraybuffer' }
      )

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${new Date()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error) {
      console.log(error)
      setLoading(false)
    }

    setLoading(false)
  }

  useEffect(() => {
    const now = new Date()
    const lastWeek = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7)

    const data = {
      data_entrada: format(lastWeek, 'yyyy-MM-dd'),
      data_saida: format(now, 'yyyy-MM-dd'),
    }

    setValue('data_entrada', data.data_entrada)
    setValue('data_saida', data.data_saida)

    handleSearch(data)
  }, [])

  return (
    <>
      <HeadingPages name="Controle Kangu" />
      {isLoading && <Loader />}

      <Layout>
        <Flex
          maxW="650px"
          w="100%"
          bg="white"
          borderRadius="8px"
          boxShadow="0 0 60px rgba(0, 0, 0, 0.05)"
          p="4"
          mx="auto"
          my="8"
          gap={2}
          as="form"
          onSubmit={handleSubmit(handleSearch)}
        >
          <Input type="date" {...register('data_entrada')} />
          <Input type="date" {...register('data_saida')} />
          <Input type="text" {...register('numero_pedido')} placeholder="N. Pedido" />
          <Button colorScheme="blue" maxW="130px" w="100%" type="submit" isLoading={isLoading} disabled={isLoading || loading}>
            Buscar
          </Button>
        </Flex>

        <Button
          colorScheme="green"
          onClick={generateExcel}
          mb={2}
          leftIcon={<ImFileExcel />}
          disabled={!listKangu || listKangu.length === 0}
          loadingText="Gerando Excel"
          isLoading={loading}
        >
          Gerar Excel
        </Button>

        <QueryErrorResetBoundary>
          <ErrorBoundary
            fallbackRender={({ resetErrorBoundary }) => (
              <Flex
                maxW="650px"
                w="100%"
                bg="white"
                borderRadius="8px"
                boxShadow="0 0 60px rgba(0, 0, 0, 0.05)"
                p="4"
                mx="auto"
                my="8"
                gap={2}
                as="form"
                onSubmit={handleSearch}
              >
                <Button colorScheme="blue" maxW="130px" w="100%" type="submit" isLoading={isLoading} disabled={isLoading || loading}>
                  Buscar
                </Button>
              </Flex>
            )}
            onReset={() => {
              // resetInputValues()
            }}
          >
            <TableContainer w="100%" bg="white" borderRadius="8px" boxShadow="0 0 60px rgba(0, 0, 0, 0.05)" p="4">
              <Table>
                <Thead>
                  <Tr>
                    {columns.map((column) => (
                      <Th key={column}>{column}</Th>
                    ))}
                  </Tr>
                </Thead>
                <Tbody>
                  {listKangu?.map((item, index) => (
                    <Tr key={index}>
                      <Td>{item.date}</Td>
                      <Td>{item.number}</Td>
                      <Td>{item.unique}</Td>
                      <Td>{item.code}</Td>
                      <Td>{item.freight}</Td>
                      <Td textAlign="center">{item.real}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </ErrorBoundary>
        </QueryErrorResetBoundary>
      </Layout>
    </>
  )
}
